"use client";

import { useSearchParams } from "next/navigation";
import { useMemo } from "react";

import { parseDateBlockParams } from "@calcom/web/lib/dateBlock";
import type { DateBlockConfig } from "@calcom/web/lib/dateBlock";

/**
 * Reads ?date-block and ?date-from-block from the current URL and returns
 * the parsed DateBlockConfig, or null if the params are absent/invalid.
 *
 * Used by DatePicker and AvailableTimeSlots to silently hide blocked dates
 * without any UI banner — they appear as naturally unavailable to the booker.
 */
export function useDateBlock(): DateBlockConfig | null {
  const searchParams = useSearchParams();
  return useMemo(() => {
    if (!searchParams) return null;
    return parseDateBlockParams(searchParams);
  }, [searchParams]);
}
